import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { FULLWIDTH } from '../../../../../src/web/components/sections/Banner/BannerInput';
import PromotionBannerModal from '../../../../../src/web/components/PromotionBannerModal';

const propTypes = {
  onCancelEdit: PropTypes.func.isRequired,
  onFinishEdit: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  bgColor: PropTypes.string,
  fontColor: PropTypes.string,
  displayStyle: PropTypes.string,
  selectedPromos: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  })),
  promos: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

const defaultProps = {
  promos: {},
  selectedPromos: [],
  fontColor: '#fff',
  bgColor: '#000',
  displayStyle: FULLWIDTH,
};

const Editor = ({
  fontColor,
  bgColor,
  displayStyle,
  promos,
  selectedPromos,
  isEditing,
  onCancelEdit,
  onFinishEdit,
  facilityId,
}) => (
  <PromotionBannerModal
    fontColor={fontColor}
    bgColor={bgColor}
    displayStyle={displayStyle}
    promos={promos}
    selectedPromos={selectedPromos}
    showModal={isEditing}
    onFinishEdit={onFinishEdit}
    onClose={onCancelEdit}
    facilityId={facilityId}
  />
);

Editor.propTypes = propTypes;
Editor.defaultProps = defaultProps;

Editor.fragments = {
  discountPlans: gql`
    fragment PromotionBannerEditorDiscountPlans on DiscountPlan {
      availabilityText
      requirementsText
      availableForAllFacilities
      autoApply
      publicDescription
      description
      discountPlanDiscounts {
        id
        discountType
        monthNumber
        amount
      }
      hideFromWebsite
      name
      priority
      promotionType
      moveInOnly
      turnedOn
      startDate
      endDate
    }
  `,
};

export default Editor;
